/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LanguageResource } from './LanguageResource';
import {
    LanguageResourceFromJSON,
    LanguageResourceFromJSONTyped,
    LanguageResourceToJSON,
} from './LanguageResource';

/**
 * 
 * @export
 * @interface UserResource
 */
export interface UserResource {
    /**
     * 
     * @type {string}
     * @memberof UserResource
     */
    additionalProperties?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResource
     */
    authenticationSystemUserId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserResource
     */
    deleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserResource
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResource
     */
    id?: string;
    /**
     * 
     * @type {LanguageResource}
     * @memberof UserResource
     */
    languageResource?: LanguageResource;
    /**
     * 
     * @type {string}
     * @memberof UserResource
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResource
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResource
     */
    preferredEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResource
     */
    username?: string;
}

/**
 * Check if a given object implements the UserResource interface.
 */
export function instanceOfUserResource(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserResourceFromJSON(json: any): UserResource {
    return UserResourceFromJSONTyped(json, false);
}

export function UserResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'additionalProperties': !exists(json, 'additionalProperties') ? undefined : json['additionalProperties'],
        'authenticationSystemUserId': !exists(json, 'authenticationSystemUserId') ? undefined : json['authenticationSystemUserId'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'languageResource': !exists(json, 'languageResource') ? undefined : LanguageResourceFromJSON(json['languageResource']),
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'organizationId': !exists(json, 'organizationId') ? undefined : json['organizationId'],
        'preferredEmail': !exists(json, 'preferredEmail') ? undefined : json['preferredEmail'],
        'username': !exists(json, 'username') ? undefined : json['username'],
    };
}

export function UserResourceToJSON(value?: UserResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'additionalProperties': value.additionalProperties,
        'authenticationSystemUserId': value.authenticationSystemUserId,
        'deleted': value.deleted,
        'firstName': value.firstName,
        'id': value.id,
        'languageResource': LanguageResourceToJSON(value.languageResource),
        'lastName': value.lastName,
        'organizationId': value.organizationId,
        'preferredEmail': value.preferredEmail,
        'username': value.username,
    };
}

